import { NextArr1 } from "../svg/AllSvg";
import CorporateHeader from "../layout/CorporateHeader";
import { useTranslation } from "react-i18next";

const CorporateBanner = ({ title, root1, root2, root3, data }: any) => {
    const { t } = useTranslation('common');

    return (
        <div className="w-full h-[270px] xs:h-[240px] xlx:h-[315px] relative z-[2]">
            <div className="relative w-full h-full z-[2]">
                <div className="absolute top-0 left-0 right-0 bottom-0 w-full h-full" style={{ background: "linear-gradient(87deg, #162340 28%, rgba(22, 35, 64, 0.00) 94.38%)" }}></div>
                <img src={require("../../../assets/images/pattern3.png")} alt="pattern" className="absolute top-0 left-0 bottom-0 z-[1] h-full" />
                <img src={!!data?.cover_photo?.file ? data?.cover_photo?.file : require("../../../assets/images/pages4.png")} alt="bg-image" className="w-full h-full object-cover" />
            </div>
            <div className="absolute top-0 left-0 right-0 bottom-0 items-start justify-between w-full flex flex-col pb-[25px] h-full z-[2]">
                <div className="w-full h-fit">
                    <CorporateHeader bg={true} blur={true} />
                </div>

                <div className="flex flex-wrap xsm:flex-row flex-col xsm:items-end justify-between w-full container gap-y-[5px] gap-x-[15px] mms:!px-[30px]">
                    <h2 className="text-white font-bold">{title}</h2>
                    {(!!root1 && !!root2) && <h6 className="flex items-center flex-wrap gap-[10px] font-medium text-white">{!["Home", "होम"]?.includes(root1) ? <>{t("corporate.content_pages.photo_gallery.home")} <NextArr1 className="fill-white" /></> : ""} {root1} <NextArr1 className="fill-white" /> {root2} <>{!!root3 && <><NextArr1 className="fill-white" /> {root3}</>}</></h6>}
                </div>
            </div>
        </div>
    );
};

export default CorporateBanner;